import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import * as Sentry from '@sentry/browser';
import App from './App';
import { getMyProfileRequest } from './helpers/api';

Sentry.init({
  dsn: 'https://a8b92c4702e74c8d9ddd619c7734734c@sentry.hamravesh.com/5055',
  allowUrls: ['https://app.o2reco.ir', 'https://demo-app.o2reco.ir']
});
getMyProfileRequest().then((response) => {
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  gtag('js', new Date());
  gtag('config', 'G-YWTXTZNMFW', {
    org_id: response.organization.id.toString()
  });
});
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

if (module.hot) {
  module.hot.accept();
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
